import { Grid, BoxProps } from '@mui/material';

import { TextField, Typography, Box } from '@occc-app/design-system';
import { parseNumber } from '@occc-app/lib/finalFormUtils';

export const OfferFulfillmentPriorityField = (props: BoxProps) => (
  <Box {...props}>
    <Typography variant='subtitle1' paragraph>
      Set a fulfillment priority
      <Typography variant='subtitle1' fontWeight={400} component='span' color='textSecondary'>
        &nbsp;(Higher numbers mean higher up in priority)
      </Typography>
    </Typography>
    <Grid container spacing={3}>
      <Grid item xs={6}>
        <TextField
          name='fulfillmentPriorityLevel'
          label='Offer Fulfillment Priority'
          fieldProps={{ parse: parseNumber }}
        />
      </Grid>
    </Grid>
  </Box>
);
